import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import moment from 'moment';

import { fc } from 'i18n';
import { ITepEntryPass } from 'types/tep';
import DatePicker from 'core/react/general/form/DatePicker';
import { selectedLeasesIdSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface ICellProps {
  entryPass: ITepEntryPass;
}

export const Until: FC<ICellProps> = ({ entryPass }) => {
  const id = useSelector(selectedLeasesIdSelector);

  const { formState, control } = useFormContext<{ device: ITepEntryPass }>();

  const startOn: Date | undefined = useWatch({ control, name: 'device.lease.startOn' });

  const isSelected = entryPass?.id === id;
  const error = formState.errors.device?.lease?.endOn?.message;

  const disabledDate = (date: Date) => moment(date).isBefore(moment(startOn || new Date()), 'day');

  return isSelected ? (
    <Controller
      control={control}
      name="device.lease.endOn"
      rules={{ required: fc('please enter end date') }}
      render={({ value, onChange }) => (
        <div className={styles.datePicker}>
          <DatePicker placeholder={fc('end date')} value={value} onChange={onChange} disabledDate={disabledDate} />
          {/*/!*TODO: error messages should be moved to corresponding form components when they are being refactored*!/*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  ) : (
    <div>{entryPass.lease?.endOn || '-'}</div>
  );
};
